<template>
  <div id="app">
    <!-- You can add a global header or navigation here if needed -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* Optional: Basic styling for the app container */
#app {
  font-family: 'Segoe UI', Arial, sans-serif;
  margin: 0;
  padding: 0;
  min-height: 100vh;
  background: #f8f9fa;
}
</style>